
import api from "../../../utilidades/interceptor";

const apiKey = process.env.REACT_APP_API_KEY;

export const getAccidentsKanban = async (params) => {
    try {
        const response = await api.get(`${apiKey}/tools/getAccidentsKanban`, { params });
        return response.data;
    } catch (error) {
        console.log("error getAccidentsKanban", error);
        return { canban: [], table: [] };
    }
};
export const getAccidentsCloseKanban = async (params) => {
    try {
        const response = await api.get(`${apiKey}/tools/getAccidentsCloseKanban`, { params });
        return response.data;
    } catch (error) {
        console.log("error getAccidentsCloseKanban", error);
        return { canban: [], table: [] };
    }
};

export const getAccidents = async (params) => {
    try {
        const response = await api.get(`${apiKey}/tools/getAccidents`, { params });
        return response.data;
    } catch (error) {
        console.log("error getAccidents", error);
        return null;
    }
};

export const getTipoColision = async () => {
    try {
        const response = await api.get(`${apiKey}/tools/getTipoColision`);
        return response.data;
    } catch (error) {
        console.log("error getTipoColision", error);
        return null;
    }
};

export const getAccidentsClose = async (params) => {
    try {
        const response = await api.get(`${apiKey}/tools/getAccidentsClose`, { params });
        return response.data;
    } catch (error) {
        console.log("error getAccidentsClose", error);
        return null;
    }
};
export const updateAccidents = async (params) => {
    try {
        const response = await api.patch(`${apiKey}/tools/updateAccidents`, params);
        return response.data;
    } catch (error) {
        console.log("error", error);
    }
};
export const updateAccidentsFull = async (params) => {
    try {
        const response = await api.patch(`${apiKey}/tools/updateAccidentsFull`, params);
        return response.data;
    } catch (error) {
        console.log("error", error);
    }
};

export const getIncidentesByUnidad = async (idUnidad) => {
    try {
        const response = await api.get(`${apiKey}/tools/getIncidentsByUnit`, { params: { id_unidad: idUnidad } });
        return response.data ?? [];
    } catch (error) {
        console.log("error getIncidentesByUnidad", error);
        return [];
    }
};

export const crearDescuentoOperador = async (data) => {
    try {
        const response = await api.post(`${apiKey}/tools/createDiscount`, data);
        return response.data;
    } catch (error) {
        console.log("error crearDescuentoOperador", error);
        throw error;
    }
};

export const asignarDescuentoASiniestro = async (idSiniestro, idDescuento) => {
    try {
        const response = await api.patch(`${apiKey}/tools/assignDiscount`, { id_siniestro: idSiniestro, id_descuento: idDescuento });
        return response.data;
    } catch (error) {
        console.log("error asignarDescuentoASiniestro", error);
        throw error;
    }
};
export const getTipoSiniestro = async () => {
    try {
        const response = await api.get(`${apiKey}/tools/getTipoSiniestro`);
        return response.data;
    } catch (error) {
        console.log("error getTipoSiniestro", error);
        throw error;
    }
};
export const getColaborators = async () => {
    try {
        const response = await api.get(`${apiKey}/tools/getColaborators`);
        return response.data;
    } catch (error) {
        console.log("error getColaborators", error);
        throw error;
    }
};
export const getSeveridad = async () => {
    try {
        const response = await api.get(`${apiKey}/tools/getSeveridad`);
        return response.data;
    } catch (error) {
        console.log("error getSeveridad", error);
        throw error;
    }
};
export const getIncidentes = async (fecha,id_unidad) => {
    // fecha en formato yyyy-mm-dd
    try {
        const response = await api.get(`${apiKey}/tools/getIncidentes?fecha=${fecha}&id_unidad=${id_unidad}`);
        return response.data;
    } catch (error) {
        console.log("error getIncidentes", error);
        throw error;
    }
};
export const asignarIncidente = async (id_incidente,id_siniestro) => {
    try {
        const params = {
            id_incidente: id_incidente,
            id_siniestro: id_siniestro
        }
        const response = await api.patch(`${apiKey}/tools/asignarIncidente`, params);
        return response.data;
    } catch (error) {
        console.log("error asignarIncidente", error);
        throw error;
    }
};
export const getChofer = async () => {
    try {
        const response = await api.get(`${apiKey}/tools/getChofer`);
        return response.data;
    } catch (error) {
        console.log("error getChofer", error);
        throw error;
    }
};

// ── Descuentos (mismo endpoint que Descuentos.jsx) ────────────────────────────
export const insertDescuento = async (data) => {
    try {
        const result = await api.post(`${apiKey}/talentoHumano/insertDescuento`, { dataReq: data });
        return result.data;
    } catch (error) {
        console.log("error insertDescuento", error);
        throw error;
    }
};

export const getDescuentoOperadorById = async (id) => {
    try {
        const result = await api.get(`${apiKey}/talentoHumano/getDescuentoOperadorById?id=${id}`);
        return result.data;
    } catch (error) {
        console.log("error getDescuentoOperadorById", error);
        throw error;
    }
};

export const updateDescuentoOperador = async (data) => {
    try {
        const result = await api.patch(`${apiKey}/talentoHumano/updateDescuentoOperador`, { dataReq: data });
        return result.data;
    } catch (error) {
        console.log("error updateDescuentoOperador", error);
        throw error;
    }
};

export const getGruposDesc = async () => {
    try {
        const response = await api.get(`${apiKey}/talentoHumano/getGrupos`);
        return (response.data ?? []).map(g => ({ label: `${g.SIGLAS} - ${g.DESCRIPCION}`, value: g.ID }));
    } catch (error) {
        console.log("error getGruposDesc", error);
        return [];
    }
};

export const getHerramientasOperador = async () => {
    try {
        const response = await api.get(`${apiKey}/talentoHumano/getDescuentosHerramienta`);
        return (response.data ?? [])
            .filter(h => h.OPERADOR === true)
            .map(h => ({ label: h.HERRAMIENTA, value: h.ID }));
    } catch (error) {
        console.log("error getHerramientasOperador", error);
        return [];
    }
};

export const getSiniestroAdjuntos = async (idSiniestro) => {
    try {
        const response = await api.get(`${apiKey}/tools/siniestros/${idSiniestro}/adjuntos`);
        return response.data;
    } catch (error) {
        console.log("error getSiniestroAdjuntos", error);
        throw error;
    }
};

export const uploadSiniestroFotos = async (idSiniestro, formData) => {
    try {
        const response = await api.post(`${apiKey}/tools/siniestros/${idSiniestro}/fotos`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error) {
        console.log("error uploadSiniestroFotos", error);
        throw error;
    }
};

export const deleteSiniestroFotoSlot = async (idSiniestro, slot) => {
    try {
        const response = await api.delete(`${apiKey}/tools/siniestros/${idSiniestro}/fotos/${slot}`);
        return response.data;
    } catch (error) {
        console.log("error deleteSiniestroFotoSlot", error);
        throw error;
    }
};

export const uploadSiniestroArchivos = async (idSiniestro, formData) => {
    try {
        const response = await api.post(`${apiKey}/tools/siniestros/${idSiniestro}/archivos`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error) {
        console.log("error uploadSiniestroArchivos", error);
        throw error;
    }
};

export const deleteSiniestroArchivo = async (idSiniestro, archivoId) => {
    try {
        const response = await api.delete(`${apiKey}/tools/siniestros/${idSiniestro}/archivos/${archivoId}`);
        return response.data;
    } catch (error) {
        console.log("error deleteSiniestroArchivo", error);
        throw error;
    }
};
